<div class="transcript-filing-container">
  @if (isTranscriptProcessing()) {
    <div class="transcript-processing-overlay">
      <div class="processing-message">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <h2>{{ 'ITP.loadingDataHeader' | translate }}</h2>
        <p>{{ 'ITP.loadingDataMessage' | translate }}</p>
      </div>
    </div>
  }
  <div class="transcript-header">
    <p-button
      type="button"
      variant="text"
      severity="secondary"
      icon="fa-solid fa-arrow-left"
      tooltipPosition="bottom"
      showDelay="500"
      [attr.aria-label]="'back' | translate"
      [pTooltip]="'back' | translate"
      (click)="onBack()"
    ></p-button>
    <span
      class="file-name"
      tooltipPosition="bottom"
      showDelay="500"
      [pTooltip]="currentDocument()?.fileName ?? ''"
      >{{ currentDocument()?.fileName }}</span
    >
    @if (showStatusButton()) {
      <div class="xs-btn-container">
        <p-button
          class="dap-view-confidence-status"
          tooltipPosition="top"
          showDelay="500"
          [label]="statusTranslationKey() | translate"
          [ngClass]="statusClass()"
          [pTooltip]="'confidenceModal.viewConfidenceReasoning' | translate"
          [disabled]="isExporting()"
          (click)="onStatusClick()"
        ></p-button>
      </div>
    }
  </div>
  <p-splitter
    [minSizes]="[15, 40]"
    [panelSizes]="[40, 60]"
  >
    <!-- Document Viewer Panel -->
    <ng-template pTemplate="panel">
      <div
        class="document-viewer-column"
        role="region"
        aria-label="Document Viewer"
      >
        <div class="relative-wrapper">
          <div
            class="document-viewer-container"
            [hidden]="showUnsupportedFileMessage() || documentLoadError()"
          >
            <app-document-viewer
              #documentViewer
              [base64Content]="currentDocumentBase64Content()"
              [isProcessingTranscript]="isTranscriptProcessing()"
              [isInTranscriptUpload]="true"
              [ecmDocId]="currentDocument()?.ecmDocId"
              (unsupportedFileType)="showUnsupportedFileMessage.set(true)"
            >
            </app-document-viewer>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- Transcript Data Panel -->
    <ng-template pTemplate="panel">
      <div
        class="transcript-data-column"
        role="main"
      >
        @if (currentDocument()) {
          <app-itp-extraction-data
            [documentId]="documentId"
            [metadata]="currentDocument()"
            [documentViewer]="documentViewer"
            (lockStateChanged)="onLockStateChanged($event)"
            (statusChanged)="onTranscriptStatusChanged($event)"
          ></app-itp-extraction-data>
        }
      </div>
    </ng-template>
  </p-splitter>
</div>

<p-confirmDialog></p-confirmDialog>
